function generateCoperniqRecordLinkFromId(coperniqId) {
    if(!!coperniqId) {
        return `https://app.coperniq.io/83/requests/${coperniqId}?`;
    }
}

module.exports = {
    generateCoperniqRecordLinkFromId
}
